import { TextField, Typography } from '@mui/material';
import { useState } from 'react';

function CustomTextField({ label, multiline, value, setErrors, errors, onChange, maxLength }) {
  const handleChange = (event) => {
    //console.log("me1")
    const inputText = event.target.value;
    if (inputText.length > maxLength) {
      setErrors({ [label]: 'maximum text length exceeded' });
      //console.log("me2")
    } else {
      setErrors({});
      //console.log("me3")
    }
    onChange(inputText);
  };

  return (
    <div>
      <TextField
        style={{ marginTop: '10px' }}
        fullWidth={true}
        variant="outlined"
        id="outlined-multiline-static"
        label={label}
        multiline={multiline}
        minRows={10}
        maxRows={20}
        value={value}
        error={errors[label]}
        onChange={handleChange}
      />
      <Typography
        variant="body"
        style={{ padding: '0.5rem' }}
        color={value?.length > maxLength ? 'error' : 'textSecondary'}
      >
        {value.length} / {maxLength} characters
      </Typography>
    </div>
  );
}

export default CustomTextField;
